import React, { useEffect, useRef, useState } from 'react'
import './Careers.scss'
import { useInView } from 'react-intersection-observer'
import CareersForm from 'src/components/CareersForm'

const Careers = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME

  const root = document.getElementById('root')
  root.classList.add('black-bck')

  useEffect(() => {
    document.title = companyName + ' - Careers'

    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute("content", ` At ${companyName}, our greatest asset is our team. We are passionate about creating an inclusive, collaborative environment where innovation thrives.`)
    }
  }, [])

  const [openSection, setOpenSection] = useState<string | null>(null)

  const toggleSection = (section: string) => {
    setOpenSection(openSection === section ? null : section)
  }

  return (
    <section className="careers">

      <div className="section-heading">
        <div className="container">
          <h1>Join Our Team</h1>
        </div>
      </div>


      <div className="container careers-wrapper">
        <div className="careers-left">
          <p>
            At {companyName}, our greatest asset is our team. We are passionate about creating an inclusive, collaborative environment where innovation thrives.
          </p>
          <p>
            As a leading provider of software contracting services, we are looking for skilled developers to join our team. Whether you are an experienced contractor or beginning your freelance
            career, we want to hear from you!
          </p>

          <div className="accordion">
            <div className={`accordion-item ${openSection === 'whyWork' ? 'open' : ''}`}>
              <button className="accordion-header" onClick={() => toggleSection('whyWork')}>
                <span>Why Work With Us?</span>
                <span className={`arrow ${openSection === 'whyWork' ? 'open' : ''}`}>&#9660;</span>
              </button>
              <div className="accordion-content">
                <ul>
                  <li><strong>Diverse projects:</strong> Work on a variety of software projects in finance, healthcare, technology, and more.</li>
                  <li><strong>Flexible work environment:</strong> We offer remote working for a better work-life balance.</li>
                  <li><strong>Collaborative culture:</strong> Join a network of talented professionals and work together on innovative solutions.</li>
                  <li><strong>Career growth:</strong> Gain experience by working on a diverse portfolio of projects.</li>
                </ul>
              </div>
            </div>

            <div className={`accordion-item ${openSection === 'lookingFor' ? 'open' : ''}`}>
              <button className="accordion-header" onClick={() => toggleSection('lookingFor')}>
                <span>What We’re Looking For?</span>
                <span className={`arrow ${openSection === 'lookingFor' ? 'open' : ''}`}>&#9660;</span>
              </button>
              <div className="accordion-content">
                <p>We are always looking for skilled software contractors. <br></br>You should be experts in:</p>
                <ul>
                  <li>Frontend Development</li>
                  <li>Backend Development</li>
                  <li>Mobile Development</li>
                  <li>Cloud Infrastructure</li>
                  <li>DevOps and Automation</li>
                  <li>UI/UX Design</li>
                  <li>Data Science and Machine Learning</li>
                  <li>Quality Assurance and Testing</li>
                </ul>
              </div>
            </div>
          </div>


          <div className="careers-image"></div>
          <h2>Our values</h2>
          <ul>
            <li><strong>Innovation:</strong> We are always looking for new ideas and creative solutions.</li>
            <li><strong>Integrity:</strong> We operate with honesty, transparency, and fairness in everything we do.</li>
            <li><strong>Collaboration:</strong> We achieve the best outcomes when we work together.</li>
          </ul>
        </div>

        <div className="careers-right">
          <h2 className="orange">Job Application</h2>
          <div className="section-description thin-gray">
            If you're excited about the opportunity to be part of our dynamic team, we'd love to hear from you!
            Please fill the form below and attach your CV.
          </div>
          <CareersForm submitButton={'Submit Application'} />
        </div>
      </div>
    </section>
  )
}

export default Careers